module.exports = __webpack_public_path__ + "static/img/30-3.89c95c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/30-3.jpg
// module id = 5Ln2
// module chunks = 0